import { Box, Card, Skeleton, Stack, useTheme } from "@mui/material";

export const SkeletonCard = () => {
  const theme = useTheme();
  return (
    <Card
      variant="outlined"
      sx={ {
        display: "flex",
        alignItems: "center",
        px: 2.5,
        py: 2,
        gap: 2,
        minHeight: 90,
        borderRadius: "0.5rem",
        background: theme.customColors.backgroundCard
      } }
    >
      { /* skeleton sinistra */ }
      <Skeleton variant="circular" width={ 36 } height={ 36 } sx={ { flexShrink: 0 } } />

      { /* skeleton centrale */ }
      <Stack sx={ { flex: 1 } } spacing={ 1 }>
        <Skeleton variant="text" width={ 220 } height={ 20 } />
        <Skeleton variant="text" width={ 160 } height={ 16 } />
        <Skeleton variant="rounded" width={ 20 } height={ 16 } />
      </Stack>

      { /* skeleton destra */ }
      <Box sx={ { display: "flex", alignItems: "center", gap: 1, flexShrink: 0 } }>
        <Skeleton variant="rounded" width={ 72 } height={ 28 } sx={ { borderRadius: "14px" } } />
        <Skeleton variant="rounded" width={ 36 } height={ 28 } sx={ { borderRadius: "14px" } } />
        <Skeleton variant="rounded" width={ 84 } height={ 32 } />
      </Box>
    </Card>
  );
};
